import React from "react";
import { api } from "../lib/api";
import { Instagram, Facebook, Twitter, Linkedin, Youtube, Music2 } from "lucide-react";

export const SiteFooter = () => (
    <footer className="py-12 bg-paper/50 border-t border-[#DDD6FE]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="grid md:grid-cols-12 gap-8 pb-10 border-b border-[#DDD6FE]/60">
                <div className="md:col-span-5">
                    <img src="/flexline-wordmark.svg" alt="Flex Line" className="h-8 w-auto mb-4" />
                    <p className="text-sm text-zinc-600 max-w-sm">
                        FlexLine Mobile — eSIM wireless plans with unlimited talk &amp; text, plus app-based
                        second phone numbers. Paid upfront, activated automatically.
                    </p>
                    <a
                        href="https://www.flexlines.store"
                        className="inline-block mt-4 font-mono text-xs text-emerald-deep link-underline"
                        data-testid="footer-website-link"
                    >
                        www.flexlines.store →
                    </a>
                </div>
                <div className="md:col-span-3">
                    <p className="font-mono text-[10px] uppercase tracking-wider text-zinc-500 mb-3">Product</p>
                    <ul className="space-y-2 text-sm">
                        <li><a href="/wireless" className="link-underline" data-testid="footer-wireless-link">Wireless plans</a></li>
                        <li><a href="/second-number" className="link-underline" data-testid="footer-second-number-link">Second phone number</a></li>
                        <li><a href="/brand" className="link-underline" data-testid="footer-brand-link">Brand &amp; logos</a></li>
                        <li><a href="/deals" className="link-underline" data-testid="footer-deals-link">Deals</a></li>
                        <li><a href="/advertise" className="link-underline" data-testid="footer-advertise-link">Advertise</a></li>
                        <li><a href="/franchise" className="link-underline" data-testid="footer-franchise-link">Become a Dealer</a></li>
                    </ul>
                </div>
                <div className="md:col-span-4">
                    <p className="font-mono text-[10px] uppercase tracking-wider text-zinc-500 mb-3">Contact</p>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <a href="tel:+18777380943" className="font-mono link-underline" data-testid="footer-support-phone">
                                Call or text (877) 738-0943
                            </a>
                        </li>
                        <li>
                            <a href="mailto:info@flexlines.store" className="font-mono link-underline" data-testid="footer-support-email">
                                info@flexlines.store
                            </a>
                        </li>
                        <li>
                            <a href="https://www.flexlines.store" className="font-mono link-underline">
                                www.flexlines.store
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-6 text-sm text-zinc-600">
                <div className="font-mono text-[11px] uppercase">© 2026 Flex Line Mobile · Built on Telnyx + Stripe</div>
                <SocialLinks />
                <div className="flex gap-8">
                    <a href="/privacy" className="link-underline" data-testid="footer-privacy-link">Privacy</a>
                    <a href="/terms" className="link-underline" data-testid="footer-terms-link">Terms</a>
                    <a href="mailto:info@flexlines.store" className="link-underline">Support</a>
                </div>
            </div>
        </div>
    </footer>
);

function SocialLinks() {
    const [links, setLinks] = React.useState({});
    React.useEffect(() => {
        api.get("/social/config").then(({ data }) => setLinks(data || {})).catch(() => {});
    }, []);
    const items = [
        { key: "instagram", icon: Instagram, label: "Instagram" },
        { key: "facebook", icon: Facebook, label: "Facebook" },
        { key: "twitter", icon: Twitter, label: "X" },
        { key: "tiktok", icon: Music2, label: "TikTok" },
        { key: "linkedin", icon: Linkedin, label: "LinkedIn" },
        { key: "youtube", icon: Youtube, label: "YouTube" },
    ].filter((i) => links[i.key]);
    if (items.length === 0) return null;
    return (
        <div className="flex items-center gap-4" data-testid="footer-social-links">
            {items.map(({ key, icon: Icon, label }) => (
                <a key={key} href={links[key]} target="_blank" rel="noopener noreferrer"
                    aria-label={label} title={label} data-testid={`social-link-${key}`}
                    className="text-zinc-500 hover:text-emerald-deep transition-colors">
                    <Icon className="w-4 h-4" />
                </a>
            ))}
        </div>
    );
}
